import { call, delay, put } from 'redux-saga/effects';
import * as R from 'remeda';
import { actionActions } from 'store/data/action';
import { createAction } from 'store/glue/operation/createAction';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';

// Persists a locally-created (temporary) action to the API via createAction
// operation, then swaps the temporary ID for the server-assigned one.
// Returns early if the operation returns undefined (missing tenantId or
// improvementAreaId — see createAction operation for guards).
export function* startAddActionSaga(
  action: ActionType<typeof improvementsActions.startAddAction>,
) {
  function* saga() {
    yield delay(500);

    const { action: temporaryAction } = action.payload;

    const createdAction: Data.Action | undefined = yield call(createAction, {
      action: temporaryAction,
    });
    if (!R.isDefined(createdAction)) return;

    yield put(improvementsActions.setSelectedActionId(createdAction.id));
    // Remove the temporary placeholder now that the real entity is in the store
    yield put(actionActions.remove(temporaryAction.id));
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
